import { render, staticRenderFns } from "./popup-device.vue?vue&type=template&id=505dd6f4&scoped=true"
import script from "./popup-device.vue?vue&type=script&lang=js"
export * from "./popup-device.vue?vue&type=script&lang=js"
import style0 from "./popup-device.vue?vue&type=style&index=0&id=505dd6f4&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "505dd6f4",
  null
  
)

export default component.exports